import { IOption } from '@cmps/ng-select';
import { forkJoin, Observable, of } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import { UserService } from '../../user.service';
import { Population } from '../enum/population.enum';
import { SelectedItem } from '../model/selected-item.model';
import {
    currentLookupState,
    currentMainState,
} from '../population-select.state';

export function setSelectionLabels(that: any): Observable<void> {
    const state = currentMainState(that);

    const obses: Array<Observable<void>> = [];

    state.selected.forEach((item) => {
        const obs = setSelectionLabel(item);
        obses.push(obs);
    });

    return forkJoin(obses).pipe(
        tap(() => {
            state.selectedAsArray = [];
            state.selected.forEach((item) => {
                state.selectedAsArray.push({
                    population: item.population,
                    id: item.id,
                    label: item.label,
                });
            });
        }),
        mapTo(null),
    );
}

function setSelectionLabel(item: SelectedItem): Observable<void> | null {
    const userService = epicDependencies.injector.get<UserService>(UserService);

    const lookupState = currentLookupState();
    let arr: IOption[] | null;

    switch (item.population) {
        case Population.User:
        case Population.Team:
            return userService.retrieve(item.id).pipe(
                tap((ret) => {
                    item.label = `${ret.firstName} ${ret.lastName}`;
                }),
                catchErrorLogRet(null),
            );
        case Population.Lob:
            arr = lookupState.lobs;
            break;
        case Population.Region:
            arr = lookupState.regions;
            break;
        case Population.Area:
            arr = lookupState.areas;
            break;
        case Population.Site:
            arr = lookupState.sites;
            break;
        case Population.SuperGroup:
            arr = lookupState.superGroups;
            break;
        case Population.PeerGroup:
            arr = lookupState.peerGroups;
            break;
        case Population.Role:
            arr = lookupState.roles;
            break;
        case Population.Queue:
            arr = lookupState.queues;
            break;
        case Population.PopulationGroup:
            arr = lookupState.populationGroups;
            break;
    }

    item.label = arr?.find((e) => e.value === item.id)?.label;

    return of(null);
}
